
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-duplicate-region.html
riot.tag2('menu-item-duplicate-region',
  '<svg class="floating-menu_icon"> <use xlink:href="#duplicate-region-icon"></use> </svg> <span class="floating-menu_label">Duplicate region</span>',
  '',
  'class="floating-menu_item {opts.classes}" onclick="{duplicateSelf}"', function(opts) {
'use strict';

var _this = this;

var _regionUi = require('lib/region-ui');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.parent.opts.canvas;

this.duplicateSelf = function (e) {
  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var x = (e.clientX - tx) / scale;
  var y = (e.clientY - ty) / scale;

  var region = _regionUi.regionUI.duplicateRegion({ id: _this.parent.id, x: x, y: y });
  _regionUi.regionUI.selectRegion(region.id);
  _this.update();

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Duplicate Region',
    label: 'Selection'
  });

  _this.parent.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-duplicate-region')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-duplicate-region.html
// module id = 712
// module chunks = 0